'use client';

import { useEffect } from 'react';

export default function YouTubeRedirect() {
  useEffect(() => {
    window.location.href = 'https://www.youtube.com/@dysteofficial';
  }, []);

  return (
    <div style={{ 
      height: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: '#0a0012',
      color: '#b282de',
      fontFamily: 'system-ui'
    }}>
      <p>redirecting to youtube...</p>
    </div>
  );
}
